module.exports = __webpack_public_path__ + "static/media/macro.af9ba3de.svg";